// Utility: Only log in development mode (Parcel)
export function developmentLog(...args: any[]) {
  if (process.env.PARCEL_ENVIRONMENT === "development") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}
